export const STAND_LOCATION_MODES = {
  GENERAL: "general",
  EXACT: "exact",
};

const hasValidNumber = (value) => Number.isFinite(Number(value));

export const hasPublicStandCoordinates = (stand = {}) =>
  hasValidNumber(stand.publicLat) && hasValidNumber(stand.publicLng);

export const canShowStandDirections = (stand = {}) => {
  const exactMode =
    stand.locationMode === STAND_LOCATION_MODES.EXACT ||
    stand.directionsEnabled === true;

  return exactMode && (hasPublicStandCoordinates(stand) || Boolean(stand.publicAddress));
};

export const getStandDirectionsQuery = (stand = {}) => {
  if (!canShowStandDirections(stand)) return "";
  if (hasPublicStandCoordinates(stand)) {
    return `${Number(stand.publicLat)},${Number(stand.publicLng)}`;
  }
  return String(stand.publicAddress || "").trim();
};

export const getStandDirectionsUrl = (stand = {}) => {
  const query = getStandDirectionsQuery(stand);
  if (!query) return "";
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(query)}`;
};

export const getStandPublicLocationLabel = (stand = {}) =>
  stand.publicLocationLabel ||
  stand.locationText ||
  [stand.city, stand.state].filter(Boolean).join(", ") ||
  [stand.county, stand.state].filter(Boolean).join(", ") ||
  "Location not listed";
